/* eslint-disable @typescript-eslint/no-explicit-any */

import { IVector3 } from '@easytwin/runtime';

export type AssetType = 'folder' | 'model' | 'material' | 'image' | 'texture';

export type ModelInfo = {
  size: IVector3;
  center: IVector3;
  materialCount: number;
  textureCount: number;
  meshCount: number;
  nodeCount: number;
  triangleCount: number;
  fileSize: number;
  textures: {
    name: string;
    width: number;
    height: number;
  }[];
  errors: { message: string; canOptimize: boolean }[] | string[];
  warnings: { message: string; canOptimize: boolean }[] | string[];
};

export interface AssetJson {
  id: string;
  name: string;
  type: AssetType;
  parentId: string;
  thumb: string;
  content: Record<string, any>;
  createdAt: string;
}

export interface AssetItem<T extends AssetType = AssetType> {
  type: AssetType;
  name: string;
  url: string | undefined;
  id: string;
  thumb: string;
  parentId: string | null;
  content: AssetTypeToContentMap[T];
  createdAt: string;
  children: AssetItem[];
}

export interface LoadingAssetItem {
  type: AssetType;
  name: string;
  id: string;
  parentId: string | null;
  progress: number;
  status: 'loading' | 'finished' | 'abort';
}

export interface ImageInfo {
  size: { x: number; y: number };
  fileSize: number;
  ext: string;
}

export type MaterialInfo = any;

export const MaterialTypeToString: Record<string, string> = {
  MeshStandardMaterial: '标准材质',
  MeshBasicMaterial: '基础材质',
  MeshPhysicalMaterial: 'PBR材质',
};

export interface AssetTypeToContentMap extends Record<AssetType, Record<string, unknown>> {
  model: {
    url: string;
    info: ModelInfo | undefined; // 旧模型没有modelinfo
  };
  folder: Record<string, unknown>;
  material: {
    url: string | undefined; // 目前材质不是个文件
    info: MaterialInfo;
  };
  image: {
    url: string;
    info: ImageInfo;
  };
}
